// Poojari ke kaam ke ghante
const DAY_START_HOUR = 6;   // 6 am
const DAY_END_HOUR = 21;    // 9 pm
const MIN_LEAD_HOURS = 1;   // Poojari ko pahunchne ka waqt

// "14:30:00" ya "14:30" se minutes nikalo
const toMinutes = (timeStr) => {
    if (!timeStr) return 0;
    const [h, m] = timeStr.split(':');
    return parseInt(h) * 60 + parseInt(m || 0);
};

// 810 se "1:30 pm"
export const minutesToLabel = (mins) => {
    const total = ((mins % 1440) + 1440) % 1440;
    const h24 = Math.floor(total / 60);
    const m = total % 60;
    const period = h24 >= 12 ? 'pm' : 'am';
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
    return `${h12}:${String(m).padStart(2, '0')} ${period}`;
};

// 810 se "13:30:00" - backend ke liye
export const minutesToValue = (mins) => {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${String(h).padStart(2, '0')}:${String(m)
        .padStart(2, '0')}:00`;
};

// "14:30:00" se "2:30 pm"
export const formatTime12h = (timeStr) => {
    if (!timeStr) return '';
    return minutesToLabel(toMinutes(timeStr));
};

// Backend "12:12:00 - 14:12:00" se {start, end} minutes
const parseBookedRange = (rangeStr) => {
    if (!rangeStr || !rangeStr.includes('-')) return null;
    const [s, e] = rangeStr.split('-').map(x => x.trim());
    const start = toMinutes(s);
    let end = toMinutes(e);
    // Aadhi raat ke paar chala gaya
    if (end <= start) end = 1440;
    return { start, end };
};

// Slot ka interval - duration ke hisaab se
const getInterval = (duration) => {
    if (!duration || duration <= 0) return 60;
    // Poore din se lamba - sirf subah ke options
    if (duration >= 480) return 60;
    // 30 min se kam - 30 min ka grid
    if (duration < 30) return 30;
    return duration;
};

// Din ka hissa - Morning / Afternoon / Evening
const getPartOfDay = (mins) => {
    if (mins < 12 * 60) return 'MORNING';
    if (mins < 17 * 60) return 'AFTERNOON';
    return 'EVENING';
};

/**
 * Slots banao ek din ke liye
 * @param durationMinutes  pooja kitni lambi hai
 * @param bookedSlots      backend se aayi strings ki list
 * @param dateStr          "2026-08-15"
 */
export const generateSlots = (
        durationMinutes, bookedSlots = [], dateStr) => {
             if ((bookedSlots || []).includes('FULL_DAY')) {
        return [];
    }
    const duration = durationMinutes || 60;
    const interval = getInterval(duration);

    // Multi-day pooja - sirf subah ke start times
    const isMultiDay = duration >= 1440;
    const endHour = isMultiDay ? 11 : DAY_END_HOUR;

    const booked = (bookedSlots || [])
        .map(parseBookedRange)
        .filter(Boolean);

    // Aaj hai toh abhi se 1 ghanta aage se shuru
    let earliest = DAY_START_HOUR * 60;
    const today = new Date().toISOString().split('T')[0];
    if (dateStr === today) {
        const now = new Date();
        const nowMins = now.getHours() * 60 + now.getMinutes()
            + MIN_LEAD_HOURS * 60;
        earliest = Math.max(earliest,
            Math.ceil(nowMins / interval) * interval);
    }

    const slots = [];
    const lastStart = endHour * 60;

    for (let t = DAY_START_HOUR * 60; t <= lastStart;
            t += interval) {

        // Pooja din khatam hone se pehle poori honi chahiye
        if (!isMultiDay
            && t + duration > DAY_END_HOUR * 60 + 60) continue;

        const tooSoon = t < earliest;

        // Kya ye slot kisi booking se takra raha hai
        const clash = booked.some(b =>
            t < b.end && b.start < t + duration);

        slots.push({
            value: minutesToValue(t),
            label: minutesToLabel(t),
            endLabel: minutesToLabel(t + duration),
            part: getPartOfDay(t),
            available: !tooSoon && !clash,
            reason: tooSoon ? 'too soon' : clash ? 'booked' : ''
        });
    }

    return slots;
};

// Slots ko Morning / Afternoon / Evening mein baanto
export const groupSlots = (slots) => {
    const groups = [
        { key: 'MORNING', label: 'Morning', items: [] },
        { key: 'AFTERNOON', label: 'Afternoon', items: [] },
        { key: 'EVENING', label: 'Evening', items: [] }
    ];
    slots.forEach(s => {
        const g = groups.find(x => x.key === s.part);
        if (g) g.items.push(s);
    });
    return groups.filter(g => g.items.length > 0);
};

// Agle N din ki list - date strip ke liye
export const getNextDays = (count = 14) => {
    const days = [];
    const dayNames = ['SUN', 'MON', 'TUE', 'WED',
        'THU', 'FRI', 'SAT'];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    for (let i = 0; i < count; i++) {
        const d = new Date();
        d.setDate(d.getDate() + i);
        days.push({
            value: d.toISOString().split('T')[0],
            dayName: dayNames[d.getDay()],
            dayNum: d.getDate(),
            month: monthNames[d.getMonth()],
            isToday: i === 0
        });
    }
    return days;
};

// "2026-08-15" se "Sat 15 Aug"
export const formatDateShort = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed',
        'Thu', 'Fri', 'Sat'];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${dayNames[d.getDay()]} ${d.getDate()} `
        + `${monthNames[d.getMonth()]}`;
};